import { StyledBackdrop } from './styles';

export default function Backdrop({ open, disableBlur, ...restProps }) {
  return <StyledBackdrop id="backdrop" open={open} disableBlur={disableBlur} {...restProps} />;
}
